import get from 'lodash/get';
import { IsInt, Min, ValidateIf, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export default class VoiceModel {
  @ValidateNested()
  @Type(() => AutoAccept)
  autoAccept: AutoAccept;

  @IsInt()
  @Min(0, { message: 'Enter a value greater than or equal to 0' })
  callWrapUpIntervalSecs: number;

  @IsInt()
  @Min(0, { message: 'Enter a value greater than or equal to 0' })
  declineCallAutoReadyIntervalSecs: number;

  abnormalDeclineThresholdMillis?: number;
  disableDeclineCall?: boolean;
  disableOutboundCallList?: [];
  hotelingEnabled?: boolean;
  shouldAutoCloseCallConversations?: boolean;
  shouldAutoOpenCallNote?: boolean;
}

class AutoAccept {
  enabled: boolean;

  @ValidateIf(props => get(props, 'enabled'))
  @IsInt()
  @Min(1, { message: 'Enter a value greater than or equal to 1' })
  delaySecs: number;
}
